export class ImageFile {
    constructor (
        public name: string,
        public url: string
    ) {}
}